export default __webpack_public_path__ + "static/media/pause.8448b50f.svg";